const domain: string = 'REQUEST_MODAL'
const domain2: string = 'YF_POPIN'

export const DISPLAY_MODAL: string = `${domain}/DISPLAY_MODAL`
export const HIDE_MODAL: string = `${domain}/HIDE_MODAL`

export const DISPLAY_YF: string = `${domain2}/DISPLAY_MODAL`
export const HIDE_YF: string = `${domain2}/HIDE_MODAL`
